export default __webpack_public_path__ + "static/media/ocx-left-to-distribute-bg.78af1f49.svg";